
import { Toast, PullRefresh, SwipeCell, Dialog, Checkbox } from "vant";
Vue.use(Checkbox);
import { Component, Vue, Watch } from "vue-property-decorator";
import { authpersonal, imgPersonal } from "@/req/user";
import NavBar from "@/components/navBar.vue";
import GeetestCaptcha from "@/components/GeetestCaptcha.vue";
@Component({
  components: { PullRefresh, SwipeCell, NavBar, GeetestCaptcha },
})
export default class Logout extends Vue {
  public verifyShow = false;
  public ncSceneId = 0;
  public count = 0;
  public isLoading = false;
  public name = "胡宇桐";
  public idcard = "3333333333333333";
  public checked = "";
  public data: any = {
    name: "",
    idcard: "",
  };

  //   @Watch("code")
  //   public codeChange() {
  //       this.
  //   }
  public mounted() {
    // console.log(this.$route.query.data);
    this.data = JSON.parse(decodeURI((this as any).$route.query.data));
  }
  public onClickLeft() {
    this.$router.go(-1);
  }
  public onRefresh() {
    setTimeout(() => {
      Toast("刷新成功");
      this.isLoading = false;
      this.count++;
    }, 1000);
  }
  public async confirmId() {
    this.verifyShow = true;
  }
  public async getVerifyParam($event) {
    const param = $event;
    this.verifyShow = false;
    let obj: any = {
      front_id: this.data.frontId,
      back_id: this.data.backId,
      idcard_front: this.data.idcardFront,
      idcard_back: this.data.idcardBack,
    };
    obj = { ...obj, ...param };
    const res = await imgPersonal(obj);
    if (res.code == 200) {
      Dialog.alert({
        message: "个人实名认证成功",
      }).then(() => {
        // on close
        this.$router.push("/authentication");
      });
      //   this.$router.push("/authentication");
    } else {
      Toast(res.msg);
    }
  }
  public linkTo() {
    window.location.href = "http://land.996box.com/certification.html";
  }
}
